export function logEvent(eventName: string, properties?: Record<string, any>) {
    // For now, just console log
    console.log(`[Analytics] ${eventName}:`, properties)
    
    // Later you can add real analytics:
    // - Posthog
    // - Google Analytics
    // - Custom event logging to your database
  }